<template>
  <!--
    This component is used by the header mega-menu. Nuxt's visibility prefetch
    otherwise downloads every linked route while the visitor is still on Home.
    Callers may opt back in with `:prefetch="true"` for a proven high-value link.
  -->
  <NuxtLink v-if="!isExternal" :to="url" :class="className" :id="id" :prefetch="prefetch">
    <slot></slot>
  </NuxtLink>
  <a v-else :href="url" :class="className" :id="id" target="_blank">
    <slot></slot>
  </a>
</template>

<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true
  },
  className: {
    type: [String, Object, Array],
    default: ''
  },
  id: {
    type: String,
    default: ''
  },
  prefetch: {
    type: Boolean,
    default: false
  }
})

const isExternal = computed(() => props.url?.startsWith('http') ?? false)
</script>
